export default __webpack_public_path__ + "locales/zh-CN/DeleteSelfProfileDialog.json?hash=4521e93a40d3ecc99735bfb03483ef8f";